import styled from '@emotion/styled';
import { APP_PROTOCOL, SITE_ROOT } from 'config';
import {
  grayDark, primary, white
} from 'core/ColorList';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { mobileLandscapeWidth } from '../../@standalone/Layout';
import ErrorSvg from '../icon/Error';

export default function ErrorTemplate() {
  const goBack = useCallback(() => {
    window.history.back();
  }, []);

  return (
    <ErrorWrapper>
      <ErrorSvg width="100%" />
      <ErrorText>앗!</ErrorText>
      <ErrorText>Something went wrong.</ErrorText>
      <ErrorSubText>
        Looks like the link is broken or you have entered a URL that doesn&apos;t
        exist.
        <br />
        Go back to our website or contact us if the problem persists.
      </ErrorSubText>
      <ErrorLinkBox>
        <ErrorGoHomeLink onClick={goBack} color={white}>
          Go Back
        </ErrorGoHomeLink>
        <ErrorContactUsLink to={`${APP_PROTOCOL}://${SITE_ROOT}/freshdesk.com/support/tickets/new`}>
          Contact Us
        </ErrorContactUsLink>
      </ErrorLinkBox>
    </ErrorWrapper>
  );
}

const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  width : 100%;
`;
const ErrorText = styled.p`
  margin-top: 20px;
  font-size: 28px;
  color: ${grayDark};
  text-align: center;
`;

const ErrorSubText = styled.p`
  margin-top: 20px;
  font-size: 18px;
  color: ${grayDark};
  text-align: center;
  line-height: 30px;
`;

const ErrorLinkBox = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 50px;
  width: 100%;
  justify-content: center;
  text-align: center;
  gap: 30px;
  @media screen and (max-width: ${mobileLandscapeWidth}) {
    flex-direction: column;
    gap: 10px;
    width : 100%;
    flex: 1;
  }
`;

const ErrorContactUsLink = styled(Link)`
  background-color: ${primary};
  color: ${white};
  display: block;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;

  @media screen and (max-width: ${mobileLandscapeWidth}) {
    flex:1;
  }
`;

const ErrorGoHomeLink = styled.button`
  border: 1px solid ${primary};
  color: ${primary};
  background-color: ${white};
  display: block;
  padding: 10px 20px;
  border-radius: 5px;
  text-decoration: none;

  @media screen and (max-width: ${mobileLandscapeWidth}) {
    flex:1;
  }
`;
